<template>
    <div class="main-page container" >
        <div class="mt-5 landing-title">Begin your coaching journey.</div>
        <div class="mt-3 landing-subtitle">
            If you haven't logged in before, you can sign up using the link that you received by email.
            <br />
            If you can't find that link, please contact <strong>coaching@umn.edu</strong>.
            <br />
            Please note that participation is by invitation only.
        </div>
        <div class="button-group mt-3" :style="themeStyle">
            <router-link to="/login">
                <button type="button" class="btn custom-button">Login</button>
            </router-link>
            <router-link to="/signup" v-if="false"><!-- signups disabled -->
                <button type="button" class="btn custom-button">Join</button>
            </router-link>
        </div>
    </div>
</template>

<script>
import { useThemeStore } from "@/stores/theme";

export default {
    name: 'LandingPage',
    setup() {
        const themeStore = useThemeStore();
        return { themeStyle: themeStore.themeStyle };
    },
};
</script>

<style>
#app {
    /* TODO: make this the global bg color */
    background-color: var(--landing-color);
}
</style>
<style scoped>
.main-page {
    justify-content: flex-start;
    text-align: center;
}

.landing-title {
    font-family: Georgia, 'Times New Roman', Times, serif;
    font-size: 3rem;
    font-weight: bold;
    color: var(--primary-color);
    text-align: center;
}

.landing-subtitle {
    font-size: 1.1rem;
    font-weight: normal;
    color: var(--primary-color);
    text-align: center;
}

.button-group {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    height: 100%;
}

.custom-button {
    width: 150px;
    border: 2px solid var(--primary-color);
    border-radius: 0;
    color: white;
    background-color: var(--primary-color);
}

.custom-button:hover {
    background-color: var(--primary-color);
}

/* Media query for mobile devices */
@media (max-width: 600px) {
    .landing-title {
        font-size: 2rem;
    }
}
</style>